import {
  recordLandingActivity,
  recordSignupActivity,
} from "@faire/deprecated-retailer-visitor-shared/actions/user/recordLoggedOutActivity";
import { useLoggedOutSuppliersPageCurrentCategory } from "@faire/deprecated-retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/Context/useLoggedOutSuppliersPageCurrentCategory";
import { trackSeoSuppliersPageView } from "@faire/web-api--source/events/seo/view/suppliersPage";
import { getLocationOrThrow } from "@faire/web/common/globals/getLocation";
import { useEffect } from "react";

export const useLoggedOutSuppliersPageRecordAndTrackAnalytics = () => {
  const categoryModel = useLoggedOutSuppliersPageCurrentCategory();
  const { mostSpecificPathIdentifier } = categoryModel;

  useEffect(() => {
    recordLandingActivity({
      category_path_identifier: mostSpecificPathIdentifier,
    });

    try {
      recordSignupActivity(
        {
          category_path_identifier: mostSpecificPathIdentifier,
        },
        getLocationOrThrow().pathname
      );
    } catch (e) {
      // If there's no window.location don't record
    }
  }, [mostSpecificPathIdentifier]);

  useEffect(() => {
    if (mostSpecificPathIdentifier) {
      trackSeoSuppliersPageView(mostSpecificPathIdentifier);
    }
  }, [mostSpecificPathIdentifier]);
};
